import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function getAllConfigList() {
  return axiosInstance.get(`configs`);
}

export function getSwitchStore(data) {
  return axiosInstance.post(`switch-store`, formatRequest(data));
}

export function getAllStore() {
  return axiosInstance.get(`store-list`);
}

export function getCountryList() {
  return axiosInstance.get(`country-list`);
}

export function getStateList(data) {
  return axiosInstance.post(`state-list`, formatRequest(data));
}

export function getCityList(data) {
  return axiosInstance.post(`city-list`, formatRequest(data));
}

export function getAllStoreOwnerList() {
  return axiosInstance.get(`/admin/store-owner-list`);
}


export function getAllStoreByOwnerList(data) {
  return axiosInstance.post(`store-by-owner`, formatRequest(data));
}

//get all unit
export function getAllUnitsList() {
  return axiosInstance.get(`units-list`);
}

//get all category
export function getAllCategoryList(data) {
  return axiosInstance.post(`category-list`, formatRequest(data));
}

//get customer all store list

export function getAllCustomerStoreList(data) {
  return axiosInstance.post(`customer/store-list-dropdown`,formatRequest(data));
}

//get wallet list
export function getWalletList(data) {
  return axiosInstance.post(`/wallet`, formatRequest(data));
}

//store owner wallet details
export function getWalletStoreOwnerCustomerDetails(data) {
  return axiosInstance.post(`/wallet/customer`, formatRequest(data));
}

//customer wallet details
export function getWalletCustomerDetails(data) {
  return axiosInstance.post(`/customer/wallet`, formatRequest(data));
}



//vendor list
export function getAllVendorList(data) {
  return axiosInstance.post(`/vendor-list`,formatRequest(data));
}



